import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import EmberPopover from 'ember-tooltips/components/ember-popover';
import LineClamp from 'garaje/components/line-clamp';

interface TruncatedColumnSignature {
  Args: {
    value: string;
  };
  Element: HTMLTableCellElement;
}

export default class TruncatedColumn extends Component<TruncatedColumnSignature> {
  @tracked wasTruncated = false;

  <template>
    <td class="table-cell border-b align-middle text-carbon-50" ...attributes>
      <LineClamp @handleTruncate={{fn (mut this.wasTruncated)}} @lines={{2}} @lineHeight={{1.25}} @text={{@value}} />

      {{#if this.wasTruncated}}
        <EmberPopover @tooltipClass="break-word w-1/3" @delay={{400}} @side="bottom-end" @text={{@value}} />
      {{/if}}
    </td>
  </template>
}
